
import SelectBox from './SelectBox.vue';
import VariableInput from './VariableInput.vue';
import Dialog from './Dialog.vue';
import ConfrimDialog from './ConfrimDialog.vue';
import ModalBase from './ModalBase.vue';
import LoadingDialog from './LoadingDialog.vue';
import AppDialogOneway from './AppDialogOneway.vue';
import OnewayDialog from './OnewayDialog.vue';

export default {
  SelectBox,
  VariableInput,
  Dialog,
  ConfrimDialog,
  ModalBase,
  LoadingDialog,
  AppDialogOneway,
  OnewayDialog,
};
